var api_url ="http://localhost:3068/api/"
var socket_url ='http://localhost:3068'
// api_url ="https://360api.sipro.app/api/"
var server = true;
if(server){
    api_url ="https://360api.sipro.app/api/"
    socket_url ='https://360api.sipro.app'
}



export {api_url,socket_url};